export function profileRequest() {
  return {
    type: '@user/PROFILE_REQUEST',
  };
}

export function profileRequestFailure() {
  return {
    type: '@user/PROFILE_REQUEST_FAILURE',
  };
}

export function profileRequestSuccess({ user }) {
  return {
    type: '@user/PROFILE_REQUEST_SUCCESS',
    payload: { user },
  };
}

export function showProfile() {
  return {
    type: '@user/SHOW_PROFILE',
  };
}

export function hideProfile() {
  return {
    type: '@user/HIDE_PROFILE',
  };
}

export function signout() {
  return {
    type: '@user/SIGN_OUT',
  };
}
